import React from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form/immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Loading } from '../../../../../loadbar/Loading';
import { LabeledText } from '../../../../../form/LabeledText';
import { LabeledSelect } from '../../../../../form/LabeledSelect';
import {
  clearVolcano as clearVolcanoLocationsAc,
  getVolcano as getVolcanoLocationAc,
  updateVolcano as updateVolcanoLocationAc,
  createVolcano as createVolcanoLocationAc,
  getStatuses as getStatusesAc,
  getMorphologies as getMorphologiesAc,
  getEruptionTimes as getEruptionTimesAc,
  getCountries as getCountriesAc,
  getRegions as getRegionsAc,
  getLocations as getLocationsAc,
  openEditConfirmation as openEditConfirmationAc,
  cancelEditConfirmation as cancelEditConfirmationAc,
} from '../../../../../../redux/volcanoes/location/edit/volcanoLocationEditActions';
import { volcanoLocationEditModel, createInitialForm, formToJson } from './volcanoLocationEditModel';
import { EditForm } from '../../../../../form/EditForm';

const model = volcanoLocationEditModel.get('name');
const initialValues = volcanoLocationEditModel.get('initialValues');


class VolcanoLocationEditPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.resetForm = this.resetForm.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {
      initialized: false,
      isAdd: false,
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Volcano Location Edit';
    const {
      match: { params: { id } },
      getVolcanoLocation,
      getLocations,
      getCountries,
      getRegions,
      getMorphologies,
      getStatuses,
      getEruptionTimes,
      history,
    } = this.props;
    const isAdd = !id;
    const state = {
      isAdd,
    };
    if (id) {
      getVolcanoLocation({ id, history });
    }
    getLocations({ history });
    getCountries({ history });
    getRegions({ history });
    getMorphologies({ history });
    getStatuses({ history });
    getEruptionTimes({ history });
    this.setState(state);
  }

  componentDidUpdate() {
    const { initialized } = this.state;
    if (!initialized) {
      const { fetched, initializeForm, volcanoLocation } = this.props;
      if (fetched) {
        initializeForm(createInitialForm(volcanoLocation));
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ initialized: true });
      }
    }
  }

  componentWillUnmount() {
    const {
      resetForm, initializeForm, setPristine, clearVolcanoLocations,
    } = this.props;
    clearVolcanoLocations();
    initializeForm(initialValues);
    resetForm();
    setPristine();
  }

  resetForm() {
    const {
      resetForm, setPristine, change, volcanoLocation,
    } = this.props;
    resetForm();
    change('', createInitialForm(volcanoLocation));
    setPristine();
  }

  cancel() {
    const { history } = this.props;
    history.goBack();
  }


  render() {
    const {
      initialized, isAdd,
    } = this.state;
    const {
      pristine,
      loading,
      countries,
      regions,
      morphologies,
      statuses,
      eruptionTimes,
      locations,
      match: { params: { id } },
      createVolcanoLocation,
      updateVolcanoLocation,
      formData,
      editConfirmationOpen,
      cancelEditConfirmation,
      openEditConfirmation,
      volcanoLocation,
    } = this.props;
    if (!initialized) {
      return (<Loading />);
    }
    return (
      <div className="haz-results-container haz-page-container">
        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">{isAdd ? 'Add Volcano Location' : 'Edit Volcano Location'}</CardTitle>

            <EditForm
              model={model}
              hazardName="Volcano"
              saving={loading}
              create={createVolcanoLocation}
              update={({ ...c }) => updateVolcanoLocation({
                ...c,
                location: {
                  pathname: '/view/hazards/volcano/loc-search',
                },
              })}
              isAdd={isAdd}
              id={id || '-1'}
              formData={formData}
              editConfirmationOpen={editConfirmationOpen}
              handleOpen={form => openEditConfirmation({ formData: formToJson(form) })}
              handleCancel={cancelEditConfirmation}
              original={volcanoLocation}
            >

              <Card>
                <CardBody>
                  <CardTitle tag="h2">IDs</CardTitle>
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-3']} model=".id" label="NCEI ID" />
                    <LabeledText formGroupClassName={['col-md-6']} model=".name" label="Name" helpModalId="volLocName" />
                  </div>
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".num" label="Previous Volcano Number" readOnly={loading} helpModalId="volLocNum" />
                    <LabeledText formGroupClassName={['col-md-6']} model=".newNum" label="Volcano Number" readOnly={loading} helpModalId="volLocNewNum" />
                  </div>

                </CardBody>
              </Card>


              <Card>
                <CardBody>
                  <CardTitle tag="h2">Location</CardTitle>
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-6']} model=".latitude" label="Latitude" readOnly={loading} helpModalId="latitude" />
                    <LabeledText formGroupClassName={['col-sm-6']} model=".longitude" label="Longitude" readOnly={loading} helpModalId="longitude" />
                  </div>
                  <div className="form-row">
                    <LabeledSelect childOptions={countries.toJS()} formGroupClassName={['col-md-4']} parentModel={model} fieldId="country" label="Country" readOnly={loading} filterable addable helpModalId="volEventCountry" />
                    <LabeledSelect childOptions={locations.toJS()} formGroupClassName={['col-md-4']} parentModel={model} fieldId="location" label="Location" readOnly={loading} filterable addable helpModalId="volLocRegion" />
                    <LabeledSelect childOptions={regions.toJS()} formGroupClassName={['col-md-4']} parentModel={model} fieldId="region" label="Region" readOnly={loading} filterable prependId addable helpModalId="volLocRegions" />
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Details</CardTitle>
                  <div className="form-row">
                    <LabeledSelect childOptions={morphologies.toJS()} formGroupClassName={['col-md-8']} parentModel={model} fieldId="morphology" label="Volcano Type" readOnly={loading} filterable addable helpModalId="volLocType" />
                    <LabeledText formGroupClassName={['col-md-4']} model=".elevation" label="Elevation" readOnly={loading} helpModalId="volLocElevation" />
                  </div>
                  <div className="form-row">
                    <LabeledSelect childOptions={statuses.toJS()} formGroupClassName={['col-md-6']} parentModel={model} fieldId="status" label="Volcano Status" readOnly={loading} filterable addable helpModalId="volLocStatus" />
                    <LabeledSelect childOptions={eruptionTimes.toJS()} formGroupClassName={['col-md-6']} parentModel={model} fieldId="timeErupt" label="Time of Eruption" readOnly={loading} filterable addable helpModalId="volLocTimeErupt" />
                  </div>
                </CardBody>
              </Card>

              <div>
                <Button disabled={loading || pristine} type="submit" color="primary" className="ml-5">{isAdd ? 'Create' : 'Update'}</Button>
                <Button disabled={loading || pristine} color="secondary" className="ml-2" onClick={this.resetForm}>Reset</Button>
                <Button disabled={loading} color="secondary" className="ml-2" onClick={this.cancel}>Cancel</Button>
              </div>
            </EditForm>

          </CardBody>
        </Card>

      </div>
    );
  }
}

VolcanoLocationEditPageUnwrapped.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  }).isRequired,
  fetched: PropTypes.bool.isRequired,
  getVolcanoLocation: PropTypes.func.isRequired,
  clearVolcanoLocations: PropTypes.func.isRequired,
  volcanoLocation: ImmutablePropTypes.map.isRequired,
  resetForm: PropTypes.func.isRequired,
  setPristine: PropTypes.func.isRequired,
  initializeForm: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  updateVolcanoLocation: PropTypes.func.isRequired,
  createVolcanoLocation: PropTypes.func.isRequired,
  history: PropTypes.shape({ goBack: PropTypes.func }).isRequired,
  loading: PropTypes.bool.isRequired,
  change: PropTypes.func.isRequired,
  countries: ImmutablePropTypes.list.isRequired,
  regions: ImmutablePropTypes.list.isRequired,
  morphologies: ImmutablePropTypes.list.isRequired,
  statuses: ImmutablePropTypes.list.isRequired,
  eruptionTimes: ImmutablePropTypes.list.isRequired,
  locations: ImmutablePropTypes.list.isRequired,
  getCountries: PropTypes.func.isRequired,
  getRegions: PropTypes.func.isRequired,
  getMorphologies: PropTypes.func.isRequired,
  getStatuses: PropTypes.func.isRequired,
  getEruptionTimes: PropTypes.func.isRequired,
  getLocations: PropTypes.func.isRequired,
  openEditConfirmation: PropTypes.func.isRequired,
  cancelEditConfirmation: PropTypes.func.isRequired,
  formData: ImmutablePropTypes.map.isRequired,
  editConfirmationOpen: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, props) => {
  const { match: { params: { id } } } = props;
  const isAdd = !id;

  const fetchedCheck = [
    state.getIn(['volcanoLocationEditPage', 'fetchedCountries']),
    state.getIn(['volcanoLocationEditPage', 'fetchedRegions']),
    state.getIn(['volcanoLocationEditPage', 'fetchedMorphologies']),
    state.getIn(['volcanoLocationEditPage', 'fetchedStatuses']),
    state.getIn(['volcanoLocationEditPage', 'fetchedEruptionTimes']),
    state.getIn(['volcanoLocationEditPage', 'fetchedLocations']),
  ];
  if (!isAdd) {
    fetchedCheck.push(state.getIn(['volcanoLocationEditPage', 'fetched']));
  }

  return {
    fetched: fetchedCheck.every(v => v),
    volcanoLocation: state.getIn(['volcanoLocationEditPage', 'volcano']),
    pristine: state.get('forms')[model].$form.pristine,
    loading: state.getIn(['volcanoLocationEditPage', 'updating']),
    countries: state.getIn(['volcanoLocationEditPage', 'countries']),
    regions: state.getIn(['volcanoLocationEditPage', 'regions']),
    morphologies: state.getIn(['volcanoLocationEditPage', 'morphologies']),
    statuses: state.getIn(['volcanoLocationEditPage', 'statuses']),
    eruptionTimes: state.getIn(['volcanoLocationEditPage', 'eruptionTimes']),
    locations: state.getIn(['volcanoLocationEditPage', 'locations']),
    formData: state.getIn(['volcanoLocationEditPage', 'formData']),
    editConfirmationOpen: state.getIn(['volcanoLocationEditPage', 'editConfirmationOpen']),
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  getVolcanoLocation: getVolcanoLocationAc,
  clearVolcanoLocations: clearVolcanoLocationsAc,
  updateVolcanoLocation: updateVolcanoLocationAc,
  createVolcanoLocation: createVolcanoLocationAc,
  getStatuses: getStatusesAc,
  getMorphologies: getMorphologiesAc,
  getEruptionTimes: getEruptionTimesAc,
  getCountries: getCountriesAc,
  getRegions: getRegionsAc,
  getLocations: getLocationsAc,
  resetForm: () => actions.reset(model),
  initializeForm: volcanoLocation => actions.load(model, volcanoLocation),
  setPristine: () => actions.setPristine(model),
  change: (field, value) => actions.change(`${model}${field}`, value),
  openEditConfirmation: openEditConfirmationAc,
  cancelEditConfirmation: cancelEditConfirmationAc,
}, dispatch);

export const VolcanoLocationEditPage = connect(mapStateToProps, mapDispatchToProps)(VolcanoLocationEditPageUnwrapped);
